module.exports = __webpack_public_path__ + "img/trx.8812bbfc.svg";